import { render } from "./HollywoodSmile.vue?vue&type=template&id=1e6b4b2e"
import script from "./HollywoodSmile.vue?vue&type=script&lang=js"
export * from "./HollywoodSmile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__